import React from 'react';

export const Loading = () => {
	return (
		<div className='loading-map d-flex justify-content-center align-items-center'>
			<div className='text-center'>
				<h3>Wait please</h3>
				<span>Locating...</span>
			</div>
		</div>
	);
};
